import { render, staticRenderFns } from "./BadgeboxSuccessNoSample.vue?vue&type=template&id=00011a8f&"
import script from "./BadgeboxSuccessNoSample.vue?vue&type=script&lang=js&"
export * from "./BadgeboxSuccessNoSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports